import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../../models/auth-api.model';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authSvc = inject(AuthService);
  const router  = inject(Router);

  const requiredRole = route.data['role'] as UserRole;
  const userRole = authSvc.currentUser()?.role ?? null;

  // owner สามารถเข้า bidder zone ได้ (ทุกคนเป็น bidder ได้)
  if (userRole === requiredRole) return true;
  if (requiredRole === 'bidder' && userRole === 'owner') return true;

  return router.createUrlTree(['/403']);
};
